document.body.classList.remove('js-stop-transition')
console.info("nslookup -type=ANY tg.rewired.moe")